Controller = require 'controller'
getExperiment = require 'lib/experiments/simple-test'
PluginButtonsView = require 'views/plugin/plugin-buttons-view'
PluginCardButtonView = require 'views/plugin/plugin-card-button-view'
simpleTest = require 'lib/experiments/simple-test'
sidebarAction = require 'views/templates/card_detail_sidebar_button'
t = require('views/internal/teacup-with-helpers')('card_detail')
trackUe = require 'debug/trackUe'
Util = require 'lib/util'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

nativeCustomFieldsEnabled = (board) ->
  board.isPluginEnabled(CUSTOM_FIELDS_ID) &&
  board.editable()

template = t.renderable ({ showCustomFields, showGetPups, hasButtons }) ->
  t.h3 'mod-no-top-margin', ->
    t.format 'plugins'
  t.div '.u-clearfix.js-button-list', ->
    if showCustomFields
      sidebarAction('js-edit-fields', 'custom-field', 'custom-fields')

  if showGetPups
    t.div ->
      t.a '.quiet-button.js-get-pups.get-pups', { href: '#' }, ->
        if hasButtons
          t.format 'get-more-pups'
        else
          t.format 'get-pups'

module.exports = class PluginCardButtonsView extends PluginButtonsView
  tagName: 'div'
  className: 'window-module u-clearfix hide'
  buttonsSelector: '.js-button-list'
  buttonView: PluginCardButtonView
  events:
    'click .js-get-pups': 'showPowerUps'

  inPupLinkExperiment: ->
    # only calling getExperiment if the board is editable bc we don't want to include
    # people in the experiment who won't see the link anyway
    experiment = getExperiment("cardBackPUpLink") if @model.getBoard().editable()
    experiment?.inExperiment && experiment?.get("showGetPups")

  hideContainer: (pluginButtons) ->
    if @inPupLinkExperiment()
      !@model.getBoard().editable()
    else
      pluginButtons.length == 0 && !nativeCustomFieldsEnabled(@model.getBoard())

  renderContainer: (pluginButtons) ->
    showCustomFields = nativeCustomFieldsEnabled(@model.getBoard())
    hasButtons = pluginButtons.length > 0 || showCustomFields
    showGetPups = @inPupLinkExperiment() && @model.getBoard().editable()

    @$el.html(template({ showCustomFields, hasButtons, showGetPups }))
    @$('.js-button-list')

  runnerOptions: ->
    command: 'card-buttons'
    board: @model.getBoard()
    card: @model

  showPowerUps: (e) ->
    Util.stop(e)

    boardView = Controller.getCurrentBoardView()
    boardView.navigateToDirectory(@model)
    trackUe('board view', 'opens', 'Power-Up directory home page', '', '', 'by clicking Power-Ups link on card-back')



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-card-buttons-view.coffee